import * as R from 'remeda';
import { ObjectId } from '../libs/bson.js';
export { ObjectId } from '../libs/bson.js';

export type HasObjectId = { _id: ObjectId };

export function isObjectId(val: unknown): val is ObjectId {
  return (
    val instanceof ObjectId ||
    (R.isObjectType(val) && '_bsontype' in val && val._bsontype === 'ObjectId')
  );
}
